.slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--tuna-spacing-1);
  min-width: 4.5rem;
  min-height: 5rem;
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-color-border);
  border-radius: var(--tuna-radius-sm);
  background: var(--tuna-color-surface);
  cursor: pointer;
}

.selected {
  border-color: var(--tuna-color-accent);
  background: var(--tuna-color-surface-elevated);
}

.active {
  outline: 2px solid var(--tuna-color-accent);
  outline-offset: -2px;
}

.chordName {
  font-size: var(--tuna-fontsize-md);
  font-weight: 600;
}

.roman {
  font-size: var(--tuna-fontsize-sm);
  color: var(--tuna-color-text-secondary);
}

.index {
  font-size: var(--tuna-fontsize-xs);
  color: var(--tuna-color-text-tertiary);
}
